import Vue from 'vue'
import Router from 'vue-router'
import storage from '../common/storage'
import constant from '../common/constant/constant'
// 引入全局函数
import cusfunc from '../common/cusfunc/cusfunc'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  routes: [
    // 主功能页
    {
      path: '/',
      name: 'home',
      component: () => import('@/pages/Home'),
      // 子页面
      children: [
        // 真主页
        {
          path: '/',
          name: 'realhome',
          component: () => import('@/pages/realhome/RealHome'),
          meta: {
            requireLogin: true
          }
        }
      ]
    },
    // 登录页面
    {
      path: '/login',
      name: 'login',
      component: () => import('@/pages/Login')
    },
    // 新增配件页面
    {
      path: '/yhpart/addPart',
      name: 'addPart',
      component: () => import('@/pages/yhpart/AddPart')
    },    
      // 新增配件页面
      {
        path: '/yhpart/updatePart',
        name: 'updatePart',
        component: () => import('@/pages/yhpart/UpdatePart')
      },   
    // 配件扫码出库页面
    {
      path: '/yhpart/partExpend',
      name: 'partExpend',
      component: () => import('@/pages/yhpart/PartExpend')
    },      
    // 配件详情页面
    {
      path: '/yhpart/partDetail',
      name: 'partDetail',
      component: () => import('@/pages/yhpart/PartDetail')
    },  
    // 门店管理页面
    {
      path: '/yhstore/storeManage',
      name: 'storeManage',
      component: () => import('@/pages/yhstore/StoreManage'),
      meta: {
        requireLogin: true
      }
    },    
    // 配件仓库导出页面
    {
      path: '/yhpart/partExpendWare',
      name: 'partExpendWare',
      component: () => import('@/pages/yhpart/PartExpendWare')
    },            
    // 日常支出记录页面
    {
      path: '/dailyexpend/addDailyExpend',
      name: 'addDailyExpend',
      component: () => import('@/pages/dailyexpend/AddDailyExpend'),
      meta: {
        requireLogin: true
      }
    },
    // 支出导出页面
    {
      path: '/dailyexpend/DailyExpendExport',
      name: 'dailyExpendExport',
      component: () => import('@/pages/dailyexpend/DailyExpendExport'),
      meta: {
        requireLogin: true
      }
    },    
    // 分类页面
    {
      path: '/typeManage',
      name: 'typeManage',
      component: () => import('@/pages/TypeManage'),
      meta: {
        requireLogin: true
      }
    },    
    // 用户管理页面
    {
      path: '/userManage',
      name: 'userManage',
      component: () => import('@/pages/UserManage'),
      meta: {
        requireLogin: true
      }
    },
    // 库存预警页面
    {
      path: '/yhinvent/inventRemind',
      name: 'inventRemind',
      component: () => import('@/pages/yhinvent/InventRemind')
    }
  ]
})

// 全局路由导航钩子
router.beforeEach((to,from,next) => {
  // 获取登录token，从localStorage获取
  const token = storage.get(constant.TOKEN_KEY);

  if(to.meta.requireLogin && cusfunc.isEmpty(token)) {
    next({
      name: 'login',
      params: {
        redirect: to.fullPath
      }
    });
  } 
  else {
    next();
  }

})

export default router

const VueRouterPush = Router.prototype.push
Router.prototype.push = function push (to) {
  return VueRouterPush.call(this, to).catch(err => err)
}



// WEBPACK FOOTER //
// ./src/router/index.js